import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'
import { PrimeTemplate } from 'primeng/api'
import { Button } from 'primeng/button'
import { Fluid } from 'primeng/fluid'
import { Panel } from 'primeng/panel'

import { parseInternalReturnUrl } from '@ti/core/auth/utils'
import { LangToggleComponent } from '@ti/core/ui-kit/layout/components/lang-toggle'
import { PasswordInputComponent } from '@ti/core/ui-kit/layout/components/password-input'

import { NewPasswordType, NewPasswordViewModel } from '../../models/new-password.model'

@Component({
  selector: 'app-new-password',
  templateUrl: 'new-password.component.html',
  styleUrl: 'new-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    Button,
    Fluid,
    LangToggleComponent,
    Panel,
    PasswordInputComponent,
    PrimeTemplate,
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class NewPasswordComponent implements OnInit {
  protected readonly activatedRoute = inject(ActivatedRoute)
  protected readonly router = inject(Router)
  protected readonly model = inject(NewPasswordViewModel)

  // TODO: Move translation keys away from tsp-admin scope
  protected labelsPrefix!: 'create-password' | 'change-password' | 'reset-password'

  public ngOnInit() {
    let mode: NewPasswordType
    if (this.router.url.includes('create-password')) {
      mode = 'create'
      this.labelsPrefix = 'create-password'
    } else if (this.router.url.includes('change-password')) {
      mode = 'change'
      this.labelsPrefix = 'change-password'
    } else if (this.router.url.includes('reset-password')) {
      mode = 'reset'
      this.labelsPrefix = 'reset-password'
    } else {
      // TODO: Implement error message for users
      console.error(`Cannot identify mode`)
      return this.router.navigate(['/'])
    }

    const secret = this.activatedRoute.snapshot.paramMap.get('secret') || undefined
    if (mode !== 'change' && !secret) {
      console.error(`Secret is missing`) // TODO: Add error message
      return this.router.navigate(['/'])
    }

    this.model.initialize(mode, secret)
  }

  protected complete() {
    if (this.model.mode() === 'change') {
      return this.router.navigate(['/'])
    }

    // A flow that started elsewhere (for example an app connection) resumes after the new password.
    const returnUrl = parseInternalReturnUrl(
      this.activatedRoute.snapshot.queryParamMap.get('returnUrl'),
    )
    return returnUrl
      ? this.router.navigate(['/', 'sign-in'], { queryParams: { returnUrl } })
      : this.router.navigate(['/', 'sign-in'])
  }
}
